export class ApiImportResults {
    public id: number | null;
    public start_time: Date | null;
    public end_time: Date | null;
    public api_name: string;
    public result_status: string;
    public result_output: string;

    constructor(data: ApiImportResultsData | void) {
        if (data === undefined) {
            this.id = null;
            this.start_time = null;
            this.end_time = null;
            this.api_name = '';
            this.result_status = '';
            this.result_output = '';
        } else {
            this.id = data.id;
            this.start_time = null;
            if (data.start_time !== null) {
                this.start_time = new Date(data.start_time);
            }

            this.end_time = null;
            if (data.end_time !== null) {
                this.end_time = new Date(data.end_time);
            }
            this.api_name = data.api_name;
            this.result_status = data.result_status;
            this.result_output = data.result_output;

        }
    }
}

export type ApiImportResultsData = {
    id: number | null;
    start_time: Date | null;
    end_time: Date | null;
    api_name: string;
    result_status: string;
    result_output: string;
}
